import React from 'react';
import { Snackbar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Redirect } from 'react-router-dom';

export function ErrorBlock({ error, ...props }) {
  const [message, setMessage] = React.useState(error.userMessage || '');
  const [errorCode, setErrorCode] = React.useState(error.errorCode || null);
  const closeSnackbar = () => setMessage(null);
  console.log(error);
  React.useEffect(() => {
    setErrorCode(error.errorCode);
    setMessage(error.userMessage);
  }, [error]);

  return errorCode === 1001 ? (
    <Redirect to="/logout" />
  ) : (
    <Snackbar
      open={!!message}
      autoHideDuration={6000}
      message={message}
      onClose={closeSnackbar}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={closeSnackbar}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    />
  );
}
